import React, { useState } from "react";
import axios from "axios";
import "./loginregister.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiurl } from "../../Constants";

function Login() {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();

  // Pulls the actual backend error message out of an axios error/response,
  // whether it comes back as a plain "message", or an "error"/"errors"
  // object/array/string.
  const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (!data) return error?.message || fallback;

    const apiErrors = data.error || data.errors;

    if (!apiErrors) return data.message || fallback;

    if (typeof apiErrors === "string") return apiErrors;

    if (Array.isArray(apiErrors)) return apiErrors.join(" ");

    // Object keyed by field, e.g. { phone: ["..."], otp: "..." }
    return Object.values(apiErrors)
      .map((v) => (Array.isArray(v) ? v.join(" ") : v))
      .join(" ");
  };

  const handleSendOtp = async () => {
    if (!mobile) {
      toast.error("Please enter your mobile number", { autoClose: 2000 });
      return;
    }

      if (!/^[0-9]{8,11}$/.test(mobile)) {
      toast.error("Enter a valid mobile number", { autoClose: 2000 });
      return;
    }

    setLoading(true);
    try {
      console.log("Sending login request", { user_name: mobile });
      const response = await axios.post(apiurl + "loginnew", {
        user_name: mobile,
      });

      console.log("Login API Response:", response.data);

      if (response.status === 200 && (response.data.success || response.data.status === true)) {
        toast.success("OTP sent successfully ✅", { autoClose: 2000 });
        setOtpSent(true);
      } else {
        toast.error(
          response.data.error || response.data.errors
            ? getApiErrorMessage({ response: { data: response.data } }, "Failed to send OTP")
            : response.data.message || "Failed to send OTP",
          { autoClose: 2000 }
        );
      }
    } catch (error) {
      console.error("Login API Error:", error.response?.data || error.message);
      toast.error(getApiErrorMessage(error, "Error sending OTP"), { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter the OTP", { autoClose: 2000 });
      return;
    }

    setLoading(true);
    try {
      console.log("Sending verifyOtp request", { phone: mobile, otp: otp });
      const response = await axios.post(apiurl + "verifyOtp", {
        phone: mobile.toString(),
        otp: otp.toString(),
      });

      console.log("Verify OTP Response:", response.data);

      if (response.status === 200 && response.data.status === true) {
        const user = response.data.user;

        localStorage.setItem("userId", user.id);
        localStorage.setItem("userName", user.name);
        localStorage.setItem("email", user.email);
        localStorage.setItem("phone_number", user.phone);

        toast.success("OTP verified successfully ✅", { autoClose: 2000 });
        navigation("/");
      } else {
        toast.error(
          response.data.error || response.data.errors
            ? getApiErrorMessage({ response: { data: response.data } }, "Invalid OTP")
            : response.data.message || "Invalid OTP",
          { autoClose: 2000 }
        );
      }
    } catch (error) {
      console.error("Verify OTP Error:", error.response?.data || error.message);
      toast.error(getApiErrorMessage(error, "Error verifying OTP"), { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="loginregister_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12"></div>
          <div className="col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <h2 className="text-center">Login with OTP</h2>

              {!otpSent ? (
                <>
                  <div className="mb-3">
                    <label className="form-label mb-2">
                      Mobile Number <sup className="mandatory_symbol">*</sup>
                    </label>
                    <input
                      type="text"
                      name="mobile"
                      className="form-control"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      maxLength={11}
                      placeholder="Enter mobile number"
                    />
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn_1_1"
                      onClick={handleSendOtp}
                      disabled={loading}
                    >
                      {loading ? "Sending OTP..." : "Send OTP"}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-3">
                    <label className="form-label mb-2">Enter OTP</label>
                    <input
                      type="text"
                      name="otp"
                      className="form-control"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="Enter the 6-digit OTP"
                    />
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn_1_1"
                      onClick={handleVerifyOtp}
                      disabled={loading}
                    >
                      {loading ? "Verifying..." : "Verify OTP"}
                    </button>
                  </div>
                  <p
                    className="text-center mt-3"
                    style={{ cursor: "pointer", color: "#76a70e" }}
                    onClick={() => setOtpSent(false)}
                  >
                    Resend OTP
                  </p>
                </>
              )}

              <p className="text-center mt-4">
                Don't have an account?{" "}
                <Link
                  to="/register"
                  style={{ color: "#76a70e", textDecoration: "none" }}
                >
                  Register
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;